/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */
/* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */
import React, { type ReactNode, useMemo } from 'react';

import { Box, type XCSS, xcss } from '@atlaskit/primitives';

import { gradients } from './constants';
import { getGradientIndexByString } from './utils';

const styles = xcss({
	width: '100%',
	height: '100%',
	backgroundSize: 'cover',
	backgroundPosition: 'center',
	overflow: 'hidden',
});

const gradientStyles = gradients.map((gradient) =>
	xcss({ backgroundImage: `linear-gradient(${gradient})` }),
);

type Props = {
	stringToHash: string;
	customStyles?: XCSS | Array<XCSS>;
	children?: ReactNode;
};

export function FallbackGradient(props: Props) {
	const gradientIndex = useMemo(
		() => getGradientIndexByString(props.stringToHash),
		[props.stringToHash],
	);
	return (
		<Box
			xcss={[
				styles,
				gradientStyles[gradientIndex],
				...(Array.isArray(props.customStyles) ? props.customStyles : [props.customStyles]),
			]}
			testId="profile-header-image-default"
		>
			{props.children}
		</Box>
	);
}
